import { render, staticRenderFns } from "./ProjectExpenseAllocationsPage.vue?vue&type=template&id=471dc627&scoped=true"
import script from "./ProjectExpenseAllocationsPage.vue?vue&type=script&lang=ts"
export * from "./ProjectExpenseAllocationsPage.vue?vue&type=script&lang=ts"
import style0 from "./ProjectExpenseAllocationsPage.vue?vue&type=style&index=0&id=471dc627&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471dc627",
  null
  
)

export default component.exports